// Single source of truth for PakMazar's public-facing company/support
// identity — the email and agent name CUSTOMERS see.
//
// Never a real admin's login email or profile name: SUPPORT_AGENT_NAME is a
// deliberately generic public identity so a customer-facing ticket/message
// never exposes which admin actually handled it. Internal admin-only views
// (e.g. the Support Inbox's own "Handled by" column) are a separate,
// admin-facing concern and are not driven by this file.
export const SUPPORT_EMAIL = 'ayist@pakmazar.az';
export const SUPPORT_AGENT_NAME = 'İlham';
